import React from 'react';
const IconNavInterfacesFill = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M22 2H2V22H12H22V18.7857V2ZM22 18.7857L12 10V22L15.6363 18.926L15.8322 18.7769L22 18.7857ZM8 6H6V8H8V6ZM10 6H18V8H10V6Z" fill="#2D2E2E"/>
</svg>
);
};
export default IconNavInterfacesFill;